export const TOGGLE_NEW_REVIEWERS = "TOGGLE_NEW_REVIEWERS"
export const UPDATE_NEW_REVIEWERS = "UPDATE_NEW_REVIEWERS"

export const TOGGLE_SEND_SUCCESS_MODAL = "TOGGLE_SEND_SUCCESS_MODAL"
export const DISMISS_BATCH_STATUS = "DISMISS_BATCH_STATUS"
